<template>
  <Head>
    <Title>Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu overlay />
  <siteblocks-entry-carousel />
</template>
